import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Layout',
    component: () => import('../views/layout'),
    children: [
      {
        name: 'Info',
        path: '/',
        component: () => import('../views/Dashboard.vue')
      },
      {
        name: 'Courses',
        path: '/courses',
        component: () => import('../views/Course.vue')
      },
      {
        name: 'Webinars',
        path: '/webinars',
        component: () => import('../views/Webinar.vue')
      },
      {
        name: 'Statistics',
        path: '/statistics',
        component: () => import('../views/Statistics.vue')
      },
      {
        name: 'CommissionList',
        path: '/commissions',
        component: () => import('../views/CommissionList.vue')
      }
    ]
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
